export const getUserIdentifier = (name: string, email: string) => {
    return name === "Administrator" ? name : email;
}

export const getCommodityColor = (commodity: string): string => {
    const commodityMap: Record<string, string> = {
        "Maize": "bg-yellow-500",
        "Sorghum": "bg-amber-700",
        "Cow Peas": "bg-green-600",
        "Rice": "bg-emerald-500",
        "Soy Beans": "bg-amber-400"
    }

    // Case-insensitive lookup
    const normalizedCommodity = commodity?.trim();
    if (!normalizedCommodity) return "bg-zinc-500";

    const key = Object.keys(commodityMap).find(
        k => k.toLowerCase() === normalizedCommodity.toLowerCase()
    );

    return key ? commodityMap[key] : "bg-zinc-500";
}
